
<template>
  <div class="slide-wrapper">
    <vueper-slides
      :visible-slides="3"
      :dragging-distance="70"
      slide-multiple
      autoplay
      fixed-height=true
      :arrows="true"
      class="no-shadow"
      :breakpoints="breakpoints"
      speed=10000
      transition-speed='1000'
    >
    <template v-slot:arrow-left>
      <div>
        <span class="arrow left"></span>
      </div>
    </template>
    <template v-slot:arrow-right>
      <div>
        <span class="arrow right"></span>
      </div>
    </template>
      <vueper-slide v-for="(slide, i) in testimonials"
        :key="i"
        :title="$t('pages.index.testimonials.' + slide + '.title')"
        :style="'background-color: ' + backgroundColor">
        <template v-slot:content>
          <hf-testimonial
            :title="$t('pages.index.testimonials.' + slide + '.title')"
            :name="$t('pages.index.testimonials.' + slide + '.name')"
            :imgUrl="$t('pages.index.testimonials.' + slide + '.imgUrl')"
            :linkedin="$t('pages.index.testimonials.' + slide + '.linkedin')"
            :quote="$t('pages.index.testimonials.' + slide + '.quote')"
          ></hf-testimonial>
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
  import { VueperSlides, VueperSlide } from 'vueperslides'
  import 'vueperslides/dist/vueperslides.css'

  export default {

    components: { VueperSlides, VueperSlide },
    props: {
      testimonials: Array,
      backgroundColor: String,
    },
    data: function() {
      return {
        breakpoints: {
          1200: {
            arrows: true,
            visibleSlides: 2,
            disableArrowsOnEdges: true,
            bullets: false
          },
          800: {
            arrows: true,
            disableArrowsOnEdges: true,
            visibleSlides: 1,
            bullets: false
          },
          400: {
            arrows: false,
            visibleSlides: 1
          }
        },
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import "@/scss/_variables";

  .slide-wrapper {

    @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
      width: 700px;
      margin: auto;
    }

    @media screen and (min-width: $screen-L-min) and (max-width: $screen-L-max) {
      width: 72%;
      margin: auto;
    }

    @media screen and (min-width: $screen-XL-min) {
      width: 50%;
      margin: auto;
    }
  }


  .vueperslides--fixed-height {
    height: 400px;
  }

  .arrow_wrapper {
    border: 1px solid $slide-blue;
    border-radius: 20px;
    background-color: $white;
  }

  .arrow {
    display: inline-block;
    border: 1px solid $slide-blue;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: white;
    opacity: 1;
  }

  .arrow:after {
    content: '';
    display: inline-block;
    margin-top: 9px;
    width: 10px;
    height: 10px;
    border-top: 3px solid $slide-blue;
  }

  /* https://codepen.io/gin85cc/pen/jrOgRq*/

  .left {
    margin-right: 1.5em;
  }

  .left:after {
    margin-left: 5px;

    border-right: 3px solid $slide-blue;
    -moz-transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
    transform: rotate(-135deg);
  }

  .right {
    margin-left: 1.5em;
  }

  .right:after {
    margin-left: -5px;
    border-right: 3px solid $slide-blue;
    -moz-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }

</style>
